import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=7289e4df"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports